import React from 'react';

// THE SET HEAD — a set's name above it, its count small beside it, a note
// after: the kit's ElementTable head, so a set reads the same as cards, as
// rows, or as a table (the kit's classes, styled once in NucleusPage.css).
export function SetHead({ title, count, note, as: Title = 'h2', className = '' }) {
    if (!title && count == null) return null;
    return (
        <header className={`ofself-element-table__head ${className}`.trim()}>
            {title && <Title className="ofself-element-table__title">{title}</Title>}
            {count != null && <span className="ofself-element-table__count">{count}</span>}
            {note && <span className="ofself-element-table__note">{note}</span>}
        </header>
    );
}

// A TITLED SET: the head, then the set, or its empty line when it holds nothing.
export function TitledSet({ title, count, note, empty, className = '', children, ...rest }) {
    const items = React.Children.toArray(children).filter(Boolean);
    return (
        <section className={`nx-set ${className}`.trim()} {...rest}>
            <SetHead title={title} count={count} note={note} />
            {!items.length && empty ? <p className="ofself-element-table__empty">{empty}</p> : items}
        </section>
    );
}
